export function parseBRL(input: unknown): number | null {
  if (input === null || input === undefined) return null;
  if (typeof input === 'number') {
    if (Number.isFinite(input)) return input;
    return null;
  }
  let s = String(input);
  // Remove currency symbol, spaces and non relevant chars except digits, dot and comma and minus
  s = s.replace(/\s/g, '').replace(/R\$\s?/gi, '').replace(/[^0-9.,-]/g, '');
  if (!s) return null;
  // If contains both '.' and ',' assume '.' are thousands and ',' is decimal (pt-BR)
  if (s.indexOf(',') > -1) {
    // Remove dots used as thousands separator
    s = s.replace(/\./g, '');
    // Replace comma with dot for parseFloat
    s = s.replace(/,/g, '.');
  } else if (/^-?\d{1,3}(\.\d{3})+$/.test(s)) {
    s = s.replace(/\./g, '');
  }
  // Handle multiple dots/hyphens gracefully
  const cleaned = s.replace(/[^0-9.-]/g, '');
  const num = parseFloat(cleaned);
  if (isNaN(num)) return null;
  return num;
}

export function formatBRLInput(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) return '0,00';
  const nf = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return nf.format(value);
}

export function formatBRLCurrency(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) return 'R$ 0,00';
  const nf = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
  return nf.format(value);
}

export function toFiniteNumber(value: unknown, fallback = 0): number {
  if (typeof value === 'number') return Number.isFinite(value) ? value : fallback;
  if (typeof value === 'string') {
    const normalized = value.trim();
    if (!normalized) return fallback;
    const parsed = normalized.includes(',') ? parseBRL(normalized) : Number(normalized);
    return parsed !== null && Number.isFinite(parsed) ? parsed : fallback;
  }
  return fallback;
}
